import { render, staticRenderFns } from "./SellerBase.vue?vue&type=template&id=42af3ef3&scoped=true"
import script from "./SellerBase.vue?vue&type=script&lang=js"
export * from "./SellerBase.vue?vue&type=script&lang=js"
import style0 from "./SellerBase.vue?vue&type=style&index=0&id=42af3ef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42af3ef3",
  null
  
)

export default component.exports